/* eslint-disable */
export default {
    error_page_not_found: "Pagina niet gevonden!",
    error_page_not_found_title: "Pagina niet gevonden",
    error_page_not_found_body: "De door jou opgevraagde pagina kon niet worden gevonden.",
    error_ltpimpact_landing_title: "Deze service is niet langer beschikbaar",
    error_ltpimpact_landing_content: "Helaas is deze site niet meer toegankelijk. Neem contact op met het Client Center van LTP via <a href=\"mailto:online@ltp.nl\">online@ltp.nl</a> of via 020 30 50 438."
};
